import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Isvg from 'react-inlinesvg';
import Page from '../containers/page';

import visitIcon from '../assets/svg/visit.svg';

import editIcon from '../assets/svg/edit.svg';
import deleteIcon from '../assets/svg/delete.svg';


import {
    Container,
    Row,
    Col,
} from 'reactstrap';

class UserListPage extends Component {
    constructor(props) {
        super(props);
        this.fetchPages = this.fetchPages.bind(this);
        this.verify = this.verify.bind(this);
        this.block = this.block.bind(this);

        this.state = {
            items: []
        };
    }

    componentDidMount() {
        this.fetchPages();


    }

    fetchPages() {
        if (!localStorage.token) {
            return;
        }
        
        fetch('https://api.freedommusic.rs/admin/users', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        }).then((res) => res.json()).then((result) => {
            console.log(result);
            this.setState({
                items: result
            })
        })


    }
    block(id){
        fetch('https://api.freedommusic.rs/admin/users/block/' + id, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`

            },
        }).then((res) => this.fetchPages())
    }
    verify(id){
        fetch('https://api.freedommusic.rs/admin/users/verify/' + id, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`

            },
        }).then((res) => this.fetchPages())

    }


    render() {

        return (
            <div className="page-wrap">
                {
                    !localStorage.token ? <Redirect to='/login' /> : null
                }

                <Container fluid className="table">

                    <Row className="page-title">
                        <Col lg="12">
                            <h3>KORISNICI</h3>
                        </Col>
                    </Row>
                    <Row className="table-head">
                        <Col lg="3">
                            <span className="name">IME I PREZIME</span>
                        </Col>
                        <Col lg="2">
                            <span className="name">EMAIL</span>
                        </Col>
                        <Col lg="2">
                            <span className="name">EMAIL STATUS</span>
                        </Col>
                        <Col lg="2">
                            <span className="name">ACCOUNT STATUS</span>
                        </Col>
                        <Col lg="3" className="actions">

                            <span className="name">OPCIJE</span>
                        </Col>

                    </Row>
                    {
                        this.state.items && this.state.items.map((item, idx) => {
                            return (
                                <Row className="table-row" key={idx}>
                                    <Col lg="3">
                                        <span className="value">{item.name}</span>
                                        
                                    </Col>
                                    <Col lg="2">
                                        <span className="value">{item.email}</span>
                                    </Col>
                                    <Col lg="2">
                                        {
                                            item.emailVerified ?
                                                <span className="value">VERIFIKOVAN</span>
                                                :
                                                <span className="value">NIJE VERIFIKOVAN</span>
                                        }
                                    </Col>
                                    <Col lg="2">
                                        {
                                            item.accountVeified ?
                                                <span className="value">VERIFIKOVAN</span>
                                                :
                                                <span className="value">NIJE VERIFIKOVAN</span>
                                        }
                                    </Col>
                                    <Col lg="3" className="actions">
                                        {
                                            item.accountVeified ?
                                                <div className="approveButton">
                                                    <button className="button2" onClick={() => { this.block(item._id) }}>BLOKIRAJ</button>
                                                    <Link to={`/users/${item._id}`}><Isvg src={visitIcon} /></Link>
                                                </div>
                                                :
                                                <div className="approveButton">
                                                    <button className="button" onClick={() => { this.verify(item._id) }}>VERIFIKUJ</button>
                                                    <Link to={`/users/${item._id}`}><Isvg src={visitIcon} /></Link>
                                                </div>
                                        }
                                    </Col>

                                </Row>

                            )
                        })
                    }


                </Container>



            </div>
        );
    }
}

export default Page(UserListPage);